const navigationLinks = document.querySelectorAll(
	'.block-navigation-link__button--with-submenu'
);
const navigationHamburger = document.querySelector(
	'.block-navigation__hamburger'
);
const searchMenus = document.querySelectorAll(
	'.block-navigation-submenu--has-search'
);

const toggleNavigationLink = (e) => {
	let currentNavigationLink = e.currentTarget;
	let mobileNavigationLink = null;
	let searchMenu = null;

	if (
		e.currentTarget.classList.contains(
			'block-navigation-link__button--mobile'
		) &&
		e.currentTarget?.dataset?.buttonId
	) {
		currentNavigationLink = document.getElementById(
			e.currentTarget.dataset.buttonId
		);
		mobileNavigationLink = e.currentTarget;

		if (!currentNavigationLink) {
			return;
		}

		if (
			window.innerWidth < 1440 &&
			!currentNavigationLink.classList.contains(
				'block-navigation-link__button--search'
			)
		) {
			navigationHamburger.click();
		}
	}

	currentNavigationLink.parentElement.classList.toggle('active');

	if (currentNavigationLink?.dataset?.submenuId) {
		searchMenu = document.getElementById(
			currentNavigationLink.dataset.submenuId
		);
	}

	const isSearch = currentNavigationLink.classList.contains(
		'block-navigation-link__button--search'
	);

	if (isSearch && navigationHamburger.classList.contains('active')) {
		const toggleEvent = new CustomEvent('toggle-navigation-hamburger', {
			detail: {
				navigationHamburger,
			},
		});

		window.dispatchEvent(toggleEvent);
	}

	if (currentNavigationLink.parentElement.classList.contains('active')) {
		navigationLinks.forEach((navigationLink) => {
			if (navigationLink === currentNavigationLink) {
				return;
			}

			setClosingClass(navigationLink.parentElement);
			navigationLink.parentElement.classList.remove('active');
			navigationLink.setAttribute('aria-expanded', false);
		});

		searchMenus.forEach((searchMenuElement) => {
			searchMenuElement.classList.remove('active');
		});

		currentNavigationLink.setAttribute('aria-expanded', true);

		if (mobileNavigationLink) {
			mobileNavigationLink.setAttribute('aria-expanded', true);
		}

		if (searchMenu) {
			searchMenu.classList.add('active');
		}
	} else {
		setClosingClass(currentNavigationLink.parentElement);
		currentNavigationLink.setAttribute('aria-expanded', false);

		if (mobileNavigationLink) {
			mobileNavigationLink.setAttribute('aria-expanded', false);
		}

		if (searchMenu) {
			searchMenu.classList.remove('active');
		}
	}

	if (currentNavigationLink.parentElement.classList.contains('active')) {
		const openEvent = new CustomEvent('navigation-submenu-opened', {
			detail: {
				currentElement: currentNavigationLink,
				submenuOpen: true,
				isSearch,
				mobileNavigationLink,
			},
		});

		window.dispatchEvent(openEvent);
	} else {
		const closeEvent = new CustomEvent('navigation-submenu-closed', {
			detail: {
				currentElement: currentNavigationLink,
				submenuOpen: false,
				mobileNavigationLink,
			},
		});

		window.dispatchEvent(closeEvent);
	}
};

const setClosingClass = (navigationLink) => {
	navigationLink.classList.add('closing');

	setTimeout(() => {
		navigationLink.classList.remove('closing');
	}, 400);
};

const closeNavigationLinks = () => {
	if (0 === navigationLinks.length) {
		return;
	}

	let closedSubmenu = false;

	navigationLinks.forEach((navigationLink) => {
		if (navigationLink.parentElement.classList.contains('active')) {
			setClosingClass(navigationLink.parentElement);
			navigationLink.parentElement.classList.remove('active');
			navigationLink.setAttribute('aria-expanded', false);

			closedSubmenu = true;
		}
	});

	searchMenus.forEach((searchMenu) => {
		searchMenu.classList.remove('active');
	});

	if (closedSubmenu) {
		const closeEvent = new CustomEvent('navigation-submenu-closed', {
			detail: { currentElement: navigationLinks[0], submenuOpen: false },
		});

		window.dispatchEvent(closeEvent);
	}
};

if (navigationLinks.length > 0) {
	navigationLinks.forEach((navigationLink) => {
		navigationLink.addEventListener('click', toggleNavigationLink);

		const containedSubMenu = navigationLink.parentElement.querySelector(
			'.block-navigation-submenu.is-style-contained'
		);

		if (containedSubMenu) {
			navigationLink.parentElement.classList.add(
				'block-navigation-link--has-contained-submenus'
			);
		}
	});
}

window.addEventListener('navigation-opened', closeNavigationLinks);
window.addEventListener('navigation-closed', closeNavigationLinks);
window.addEventListener('navigation-search-opened', closeNavigationLinks);
